import Vue from 'vue';
import Sidebar from '@/core/sidebar/sidebar.component';

export default class LoginService {
  public openLogin(instance: Vue): void {
    instance.$emit('bv::show::modal', 'login-page');
  }
}
